<!-- Head Office Home Component -->
<div class="header-section">
  <div class="header-content">
    <div class="header-left">
      <h1 class="page-title">
        <i class="pi pi-building"></i>
        Head Office Home
      </h1>
      <p class="page-subtitle">Overview of sales orders and business metrics</p>
    </div>
  </div>
</div>

<div class="head-office-container">
  <!-- Toast Notifications -->
  <p-toast key="main"></p-toast>

  <!-- Loading State -->
  <div *ngIf="loadingPage" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner
        strokeWidth="3"
        animationDuration=".5s"
      ></p-progressSpinner>
      <p class="loading-text">Loading dashboard data...</p>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loadingPage" class="main-content">
    <!-- Statistics Cards -->
    <div class="stats-section">
      <div class="stats-grid">
        <!-- Orders Card -->
        <div class="stat-card">
          <div class="stat-header">
            <div class="stat-icon orders-icon">
              <i class="pi pi-shopping-cart"></i>
            </div>
            <div class="stat-info">
              <h3 class="stat-title">Total Orders</h3>
              <p class="stat-subtitle">All sales orders</p>
            </div>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ order_count }}</div>
            <!-- <div class="stat-change">
              <span class="change-indicator positive">
                <i class="pi pi-arrow-up"></i>
                24 new
              </span>
              <span class="change-text">since last visit</span>
            </div> -->
          </div>
        </div>

        <!-- Customers Card -->
        <div class="stat-card">
          <div class="stat-header">
            <div class="stat-icon customers-icon">
              <i class="pi pi-users"></i>
            </div>
            <div class="stat-info">
              <h3 class="stat-title">Nurses</h3>
              <p class="stat-subtitle">Registered customers</p>
            </div>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ nurse_count }}</div>
            <!-- <div class="stat-change">
              <span class="change-indicator positive">
                <i class="pi pi-arrow-up"></i>
                520
              </span>
              <span class="change-text">newly registered</span>
            </div> -->
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-header">
            <div class="stat-icon revenue-icon">
              <i class="pi pi-building"></i>
            </div>
            <div class="stat-info">
              <h3 class="stat-title">Clinics</h3>
              <p class="stat-subtitle">Registered clinics</p>
            </div>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ clinic_count }}</div>
            <!-- <div class="stat-change">
              <span class="change-indicator positive">
                <i class="pi pi-arrow-up"></i>
                520
              </span>
              <span class="change-text">newly registered</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Orders Section -->
    <div class="recent-orders-section" *ngIf="sales_orders.length > 0">
      <div class="section-card">
        <div class="card-header">
          <h3 class="card-title">
            <i class="pi pi-list"></i>
            Recent Sales Orders
          </h3>
          <p class="card-subtitle">Latest orders from clinics and customers</p>
        </div>
        <div class="card-content">
          <div class="orders-list">
            <div
              *ngFor="let order of sales_orders.slice(0, 5)"
              class="order-item"
            >
              <div class="order-info">
                <div class="order-icon">
                  <i class="pi pi-file-text"></i>
                </div>
                <div class="order-details">
                  <h4 class="order-title">Order #{{ order.id || "N/A" }}</h4>
                  <p class="order-subtitle">
                    {{ order.clinic.name || "Unknown Clinic" }}
                  </p>
                </div>
              </div>
              <div class="order-status">
                <span class="status-badge pending">{{ order.order_status }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="sales_orders.length === 0 && !loadingPage" class="empty-state">
      <div class="empty-content">
        <i class="pi pi-chart-line empty-icon"></i>
        <h3 class="empty-title">No Data Available</h3>
        <p class="empty-text">
          No sales orders or dashboard data is currently available.
        </p>
        <button
          pButton
          pRipple
          label="Refresh Data"
          icon="pi pi-refresh"
          class="p-button-outlined"
          (click)="refreshData()"
        ></button>
      </div>
    </div>
  </div>
</div>
